'use client'
import { useState } from 'react'

export default function Footer({ footerNavigation = {} }) {
  const [newsletterMessage, setNewsletterMessage] = useState('')
  const safeNavigation = { products: [], company: [], customerService: [], ...footerNavigation }
  return (
    <footer aria-labelledby="footer-heading" className="bg-[#222222] text-white">
      <h2 id="footer-heading" className="sr-only">Footer</h2>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="py-16">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">

            {/* Brand + about */}
            <div>
              <span className="text-2xl font-black tracking-tight uppercase text-white">
                ANTONET<span className="text-[#F93A00]">SHOP</span>
              </span>
              <p className="mt-4 text-sm text-gray-400 leading-relaxed">
                Fashion for everyone. New arrivals daily — shop the latest styles at prices you'll love.
              </p>
            </div>

            {/* Products */}
            <div>
              <h3 className="text-xs font-bold uppercase tracking-widest text-gray-300 mb-5">Shop</h3>
              <ul className="space-y-3">
                {safeNavigation.products.map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div>
              <h3 className="text-xs font-bold uppercase tracking-widest text-gray-300 mb-5">Company</h3>
              <ul className="space-y-3">
                {safeNavigation.company.map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Customer Service */}
            <div>
              <h3 className="text-xs font-bold uppercase tracking-widest text-gray-300 mb-5">Help</h3>
              <ul className="space-y-3">
                {safeNavigation.customerService.map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

          </div>

          {/* Newsletter */}
          <div className="mt-12 border-t border-gray-700 pt-10">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
              <div>
                <h3 className="text-sm font-bold uppercase tracking-widest text-white">
                  Get exclusive deals in your inbox
                </h3>
                <p className="mt-1 text-sm text-gray-400">Subscribe and save — new deals every week.</p>
              </div>
              <form className="flex w-full max-w-md gap-2" onSubmit={(event) => { event.preventDefault(); setNewsletterMessage('Newsletter signup is not available yet. Email antonetshopdb@gmail.com to request updates.') }}>
                <input
                  id="footer-email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="Enter your email"
                  aria-label="Email address"
                  className="block w-full bg-[#333333] border-0 px-4 py-2.5 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-[#F93A00]"
                />
                <button
                  type="submit"
                  className="shrink-0 bg-[#F93A00] px-5 py-2.5 text-sm font-bold uppercase tracking-wider text-white hover:bg-[#d93200] transition-colors"
                >
                  Subscribe
                </button>
              </form>
              {newsletterMessage && <p role="status" className="mt-2 text-xs text-amber-300">{newsletterMessage}</p>}
              <p className="mt-2 text-xs text-gray-500">By subscribing, you agree to receive store updates. You can unsubscribe at any time.</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-700 py-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} AntonetShop. All rights reserved.
          </p>
          <div className="flex gap-5">
            <a href={route('privacy.policy')} className="text-xs text-gray-500 hover:text-white transition-colors">Privacy Policy</a>
            <a href={route('terms.of.use')} className="text-xs text-gray-500 hover:text-white transition-colors">Terms of Use</a>
            <a href="/faq" className="text-xs text-gray-500 hover:text-white transition-colors">FAQ</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
